import loadable from '@loadable/component';

const ContextHomePage = loadable(() => import('./[contextSlug]/page'));

export const routes = [
  {
    path: ':contextSlug',
    element: <ContextHomePage />,
  },
];

